<template>
  <div :class="classes" @click="fireClick(data)">
    <span class="icon"></span>
    <span class="plate">{{ data.registrationPlate }}</span>
    <span class="model">{{ data.alias }}</span>

    <button
      v-if="buttonType !== 'none'"
      :class="`car-action ${buttonType}`"
      @click="fireClick(data)"
    ></button>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    buttonType: String,
  },
  data() {
    const classes = {};
    classes.vehicle = true;
    classes["is-" + this.data.type.toLowerCase()] = true;

    if(this.buttonType === "none") {
      classes["no-button"] = true;
    }

    return {
      classes,
    };
  },
  methods: {
    fireClick(data) {
      this.$emit("click", data);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/sass/variables";

.vehicle {
  background: #000;
  text-align: right;
  padding: 16px 20px;
  margin-bottom: 10px;
  line-height: 1;

  position: relative;
  transition: 0.2s all;

  cursor: default;
  user-select: none;
  :hover {
    cursor: pointer;
  }

  .icon {
    width: 40px;
    height: 40px;
    position: absolute;
    left: 20px;
    top: 8px;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    opacity: 0.3;
  }

  &.is-car {
    .icon {
      background-image: $carIcon;
    }
  }
  &.is-motorcycle,
  &.is-motorcycle_courier {
    .icon {
      background-image: $motorcycleIcon;
    }
  }
  &.is-truck {
    .icon {
      background-image: $truckIcon;
    }
  }

  .plate {
    display: block;
    font-size: 24px;
    font-weight: bold;
  }

  .model {
    font-size: 13px;
    text-transform: uppercase;
    color: #999;
  }

  .car-action {
    border: none;
    cursor: pointer;
    height: 24px;
    position: absolute;
    right: 9px;
    opacity: 0;
    transform: scale(0.5);
    transition: 0.3s all;
    top: 16px;
    width: 24px;
  }

  .trash {
    background: transparent $deleteIcon no-repeat center center;
    background-size: contain;
  }
  .arrow {
    background-color: transparent;
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDMxLjQ5IDMxLjQ5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMS40OSAzMS40OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiPgo8cGF0aCBkPSJNMjEuMjA1LDUuMDA3Yy0wLjQyOS0wLjQ0NC0xLjE0My0wLjQ0NC0xLjU4NywwYy0wLjQyOSwwLjQyOS0wLjQyOSwxLjE0MywwLDEuNTcxbDguMDQ3LDguMDQ3SDEuMTExICBDMC40OTIsMTQuNjI2LDAsMTUuMTE4LDAsMTUuNzM3YzAsMC42MTksMC40OTIsMS4xMjcsMS4xMTEsMS4xMjdoMjYuNTU0bC04LjA0Nyw4LjAzMmMtMC40MjksMC40NDQtMC40MjksMS4xNTksMCwxLjU4NyAgYzAuNDQ0LDAuNDQ0LDEuMTU5LDAuNDQ0LDEuNTg3LDBsOS45NTItOS45NTJjMC40NDQtMC40MjksMC40NDQtMS4xNDMsMC0xLjU3MUwyMS4yMDUsNS4wMDd6IiBmaWxsPSIjZGVkZWRlIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=);

    background-repeat: no-repeat;
    background-position: center center;
  }
}

div:hover:not(.no-button) {
  padding-right: 44px;

  & > .car-action {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
